import React from 'react';
import Drawer from '@mui/material/Drawer';
import ActiveVehicleDrawerActionStage from './actionStage/ActiveVehicleDrawerActionStage';
import { useActiveVehicle } from '../../context/ActiveVehicleProvider';
import { Box, Divider } from '@mui/material';
import ActiveVehicleDrawerHeader from './header/ActiveVehicleDrawerHeader';
import ActiveVehicleDrawerTicketStage from './ticketStage/ActiveVehicleDrawerTicketStage';
import ActiveVehicleDrawerConfirmationStage from './confirmationStage/ActiveVehicleDrawerConfirmationStage';
import ActiveVehicleDrawerTowInfoStage from './towInfoStage/ActiveVehicleDrawerTowInfoStage';
import ActiveVehicleDrawerCarPhotoStage from './carPhotoStage/ActiveVehicleDrawerCarPhotoStage';
import UppyDashboardModalGuard from 'containers/pages/CANguard/components/uppy/UppyDashboardModalGuard';
import FlowStepper from '../flowStepper/FlowStepper';
interface ActiveVehicleDrawerProps {}

const ActiveVehicleDrawer: React.FC<ActiveVehicleDrawerProps> = ({}) => {
	const { showDrawer, stage, openModal, setOpenModal, uppyTicket } =
		useActiveVehicle();
	return (
		<Drawer
			anchor={'bottom'}
			open={showDrawer}
			sx={{
				'& .MuiDrawer-paperAnchorBottom': {
					height: '100%',
					backgroundImage: 'unset',
				},
			}}
		>
			<Box display={'flex'} flexDirection={'column'} gap={2} padding={2}>
				<ActiveVehicleDrawerHeader />
				<FlowStepper />
				<Divider />
			</Box>
			{stage === 'action' && <ActiveVehicleDrawerActionStage />}
			{stage === 'carPhoto' && <ActiveVehicleDrawerCarPhotoStage />}
			{stage === 'ticket' && <ActiveVehicleDrawerTicketStage />}
			{stage === 'confirm' && <ActiveVehicleDrawerConfirmationStage />}
			{stage === 'towInfo' && <ActiveVehicleDrawerTowInfoStage />}
			<UppyDashboardModalGuard
				openDashboard={openModal}
				onCloseDashboard={() => setOpenModal(false)}
				uppy={uppyTicket}
			/>
		</Drawer>
	);
};

export default ActiveVehicleDrawer;
